import { apiServiceConstants } from "../../../../constants";
import { apiService } from "../../../../services/apiService";
import { utilService } from "../../../../services/utilService";
import { RespScheduleModel, scheduleParams } from "./Models/ScheduleSync.model";

const submitScheduleSync = async (
  params: scheduleParams
): Promise<RespScheduleModel> => {
  const respApiResult = await apiService
    .apiCall(
      `user/calender-sync/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const scheduleResp = res as RespScheduleModel;
      const result: RespScheduleModel = {
        isSuccess: scheduleResp.isSuccess,
        result: scheduleResp.result,
        status: scheduleResp.status,
        message: scheduleResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespScheduleModel = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        result: "",
      };
      return result;
    });

  return respApiResult;
};

const getAutoInitialValues = async (): Promise<any> => {
    const params: any = {
      guid: utilService.getLoggedUserGuid(
      ),
      reg_code: utilService.getNetwork(),
    };
    const respApiResult = await apiService
      .apiCall(
        `user/autosync-settings/?reg_code=` + params.reg_code,
        params,
        apiServiceConstants.GET,
        utilService.getDeviceType()
      )
      .then((res) => {
        const userAvilability = res as any;
        const result: any = {
          isSuccess: true,
          status: userAvilability.status,
          message: userAvilability.message,
          result:userAvilability
        };
        return result;
      })
      .catch((err) => {
        const result: any = {
          isSuccess: false,
          message: err.message,
          status: err.status,
        };
        return result;
      });
      return respApiResult;
  };

const handleErrorResponse = () => {};

export const scheduleService = {
  submitScheduleSync,
  handleErrorResponse,
  getAutoInitialValues
};
